import { render, staticRenderFns } from "./quesPlay3.vue?vue&type=template&id=55df24c7"
import script from "./quesPlay3.vue?vue&type=script&lang=js"
export * from "./quesPlay3.vue?vue&type=script&lang=js"
import style0 from "./quesPlay3.vue?vue&type=style&index=0&id=55df24c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports